import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutAlignRight: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="layout-align-right"><path d="M3.75 3.75L3.75 3L3 3L3 3.75L3.75 3.75ZM20.25 3.75H21V3L20.25 3V3.75ZM20.25 20.25V21H21V20.25H20.25ZM3.75 20.25H3L3 21H3.75V20.25ZM15.5 16.25V17H17V16.25H15.5ZM17 7.75V7H15.5V7.75H17ZM3.75 4.5L20.25 4.5V3L3.75 3L3.75 4.5ZM19.5 3.75V20.25H21V3.75H19.5ZM20.25 19.5H3.75V21H20.25V19.5ZM4.5 20.25L4.5 3.75L3 3.75L3 20.25H4.5ZM17 16.25V7.75H15.5V16.25H17Z" fill="currentColor"/></CentralIconBase>;
};

export default IconLayoutAlignRight;
